// extracted by mini-css-extract-plugin
export var actions = "_a6-8";
export var arrow = "_a6-5";
export var card = "_a6-0";
export var cardWrapper = "_a6-9";
export var fieldName = "_a6-3";
export var newValue = "_a6-6";
export var oldValue = "_a6-4";
export var orangeGlowFade = "_a6-c";
export var productSection = "_a6-1";
export var scrollToBottom = "_a6-b";
export var scrollToBottomAnchor = "_a6-a";
export var scrollToBottomIcon = "_a6-d";
export var showAllButton = "_a6-7";
export var table = "_a6-2";